import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/form/custom-button";

const FileNotFound = ({
    icon,
    iconSize=150,
    description,
    actionText,
    navigateLink=null,
    ...sx
}) => {
    const theme = useTheme();

    const navigate = useNavigate();

    return (
        <>
            <Box 
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    ...sx
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <Box
                        width={iconSize}
                        height={iconSize}
                    >
                        <img 
                            src={icon}
                            alt="file" 
                            width='100%' 
                        />
                    </Box>

                    <Typography
                        fontWeight={500}
                        fontSize={{xs: 12, lg: 16}}
                        textAlign="center"
                        lineHeight={1.5}
                        color={theme.palette.text.secondary}
                        sx={{
                            pt: {xs: 0, md: 6},
                            pb: {xs: 2, md: 5}
                        }}
                    >
                        {description}
                    </Typography>

                    {
                        navigateLink
                        ?
                        <CustomButton 
                            label={actionText}
                            onClick={() => {
                                navigate(navigateLink);
                            }}
                            needAnimation
                        />
                        :
                        <></>
                    }
                </Stack>
            </Box>
        </>
    );
}

export default FileNotFound;